import { PageContainer } from '@/components'

import { ReleaseNotesAccordion } from './components'
import { useReleaseNotes } from './hooks'

export const ReleaseNotesPage = () => {
  const { releaseNotes, isFetching } = useReleaseNotes()

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs items={[{ title: 'Release Notes' }]} />
      }>
      <ReleaseNotesAccordion items={releaseNotes} />
    </PageContainer>
  )
}
